import React from "react";

const PythonPengembanganLogika: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Python Coding Challenge merupakan kompetisi pemrograman individu yang ditujukan bagi siswa SMP
        dan SMA untuk mengasah kemampuan berpikir logis, analitis, dan
        sistematis. Di tengah pesatnya perkembangan teknologi digital,
        keterampilan problem solving berbasis pemrograman menjadi kebutuhan
        penting bagi generasi muda.{" "} 
        <a 
        href="https://www.python.org/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline font-medium"
        >
        Python
        </a>{" "} dipilih sebagai bahasa utama karena
        memiliki sintaks yang sederhana, mudah dipelajari, serta relevan dengan
        berbagai penerapan di dunia nyata.
      </p>

      <p>
        Melalui Python Coding Challenge dalam ekosistem pembelajaran{" "}
        <strong>Indonesia Innovative Technology (IIT)</strong>, peserta
        ditantang untuk menyelesaikan berbagai permasalahan komputasional
        menggunakan Python. Soal disusun secara bertahap dari tingkat easy
        hingga challenging, mencakup konsep dasar seperti variabel,
        percabangan, dan perulangan, hingga pengolahan data dan penyusunan
        algoritma yang efisien. Pendekatan ini membantu peserta membangun
        fondasi pemrograman yang kuat sekaligus melatih ketelitian dan
        konsistensi dalam menyusun solusi.
      </p>

      <p>
        Model pembelajaran berbasis tantangan serupa juga diterapkan dalam{" "}
        <a
          href="https://osn.toki.id/OSN2025"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Olimpiade Sains Nasional (OSN) Bidang Informatika
        </a>
        , sebuah kompetisi prestisius tingkat nasional yang diselenggarakan
        oleh Puspresnas dan dikoordinasikan oleh TOKI. OSN Informatika menguji
        kemampuan berpikir komputasional siswa SMP dan SMA melalui soal-soal
        algoritma yang menuntut ketepatan logika, efisiensi solusi, serta
        kemampuan merancang algoritma yang optimal.
      </p>

      <p>
        Pada jenjang SMA, peserta OSN menyelesaikan permasalahan menggunakan
        bahasa pemrograman seperti Python, C++, atau Pascal dengan cakupan
        materi meliputi manipulasi data, pencarian, pengurutan, simulasi, dan
        perancangan algoritma. Sementara itu, jenjang SMP lebih menekankan pada
        computational thinking, logika informatika, serta pemahaman konsep
        dasar sebagai pondasi menuju tahap lanjutan. Penilaian tidak hanya
        berfokus pada hasil akhir, tetapi juga kualitas dan efisiensi solusi.
      </p>

      <p>
        Dalam konteks perkembangan teknologi seperti data science, kecerdasan
        buatan, dan otomasi, Python menjadi bahasa pemrograman yang banyak
        digunakan secara global. Oleh karena itu, Python Coding Challenge
        tidak hanya berorientasi pada kompetisi, tetapi juga sebagai sarana
        pembelajaran yang relevan dengan kebutuhan masa depan. Melalui dukungan ekosistem pembelajaran dari{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>
        , peserta tidak hanya mengembangkan kemampuan teknis, tetapi juga
        keterampilan abad ke-21 seperti berpikir kritis, manajemen waktu, dan
        ketahanan dalam menghadapi tantangan kompleks.
      </p>

      <p>👉 Cek untuk informasi Python Coding Challenge lebih lanjut.</p>
    </div>
  );
};

export default PythonPengembanganLogika;
